module.exports = __webpack_public_path__ + "src/app/assets/images/speakers/gurnell.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/images/speakers/gurnell.jpg
// module id = 614
// module chunks = 0